export default __webpack_public_path__ + "static/top1-36b83cb22166eaff72b8d7a5b08ecc35.jpg";